import { useEffect, useState } from "react";
import {
  FlagCountResponse,
  ItemGroupCount,
  ItemTypes,
  RatingTypes,
} from "../../api/Items";
import { useFetchFlagCount } from "../../api/ItemsApi";
import { ReportSummaryItemApi } from "../../api/Reports";
import ErrorMessageContainer from "../../shared-components/ErrorMessageContainer";
import LoadingSpinner from "../../shared-components/LoadingSpinner";
import { SidebarBehaviors } from "./SidebarBehaviors";

type Props = {
  report: ReportSummaryItemApi;
  behaviors?: string[];
  itemTypeNames: ItemTypes[];
  ratingType: RatingTypes;
};

const SidebarBehaviorsByType = ({
  report,
  itemTypeNames,
  ratingType,
}: Props) => {
  const {
    isLoading: loadingFlags,
    data: rawFlagsCount,
    mutate: getFlags,
    error: errorFlag,
  } = useFetchFlagCount();

  const [flagsCount, setFlagsCount] = useState<FlagCountResponse | undefined>(
    undefined
  );

  useEffect(() => {
    if (!report?.report_uuid) return;
    getFlags({
      item_type_name: [...itemTypeNames],
      behaviors: [],
      rating_type: ratingType,
      report_uuid: report.report_uuid,
    });
  }, [getFlags, itemTypeNames, ratingType, report.report_uuid]);

  useEffect(() => {
    if (rawFlagsCount?.behaviors) {
      const updatedBehaviorsGroups: ItemGroupCount[] =
        rawFlagsCount.behaviors.groups;
      const updatedTotal = updatedBehaviorsGroups.reduce(
        (acc, group) => acc + group.count,
        0
      );
      setFlagsCount({
        ...rawFlagsCount,
        behaviors: {
          groups: updatedBehaviorsGroups,
          total: updatedTotal,
        },
      });
    } else {
      setFlagsCount(rawFlagsCount);
    }
  }, [rawFlagsCount]);

  return (
    <div className="relative">
      {errorFlag && (
        <ErrorMessageContainer message={"Error Loading Behavior Count"} />
      )}
      {loadingFlags && <LoadingSpinner className="relative my-4" />}
      {!loadingFlags && (
        <SidebarBehaviors flagCount={flagsCount} hasCheckbox={false} />
      )}
    </div>
  );
};

export default SidebarBehaviorsByType;
